import { Menu, Dropdown, Avatar } from "antd";
import { connect } from "react-redux";
import {EditOutlined, LogoutOutlined } from "@ant-design/icons";
import Icon from "components/util-components/Icon";
import { signOutAction } from "redux/actions/servicio-autenticacion/Auth";
import { USER_ID, USER_NAME,AUTH_TOKEN } from "redux/constants/servicio-autenticacion/Auth";
import { concat } from "lodash-es";
import { APP_PREFIX_PATH } from "configs/AppConfig";
import jwt_decode from "jwt-decode";
import { Link } from 'react-router-dom'

// Obtiene el ID del localStorage
const getId = localStorage.getItem(USER_ID);

// Contenido editar del perfil
const menuItem = [
  {
    title: "Ver Perfil",
    icon: EditOutlined,
    path: `${APP_PREFIX_PATH}/profile/profile-edit/${getId}`,
  },
];


export const NavProfile = ({ signOutAction }) => {
  const onSignOut = () => {
    // Solo cierra la sesion de la app, sin desloguear la cuenta de Microsoft
    signOutAction();
  };


  // jwt decode
  const token = localStorage.getItem(AUTH_TOKEN);
  let decode = null;
  if (token) {
    try {
      decode = jwt_decode(token);
    } catch (error) {
      decode = null;
    }
  }
 
  // Email split
  const correo = (decode?.name || "usuario").toUpperCase();
  const atIndex = correo.indexOf('@');
  const correoBeforeAt = atIndex > 0 ? correo.substring(0, atIndex) : correo;
  const firstSplit = correoBeforeAt.split(".");
  const firstInitial = (firstSplit[0] || "U").charAt(0);
  const secondInitialMail = firstSplit[1] || "";
  const initialsEmails = firstInitial + (!secondInitialMail  ? '' : secondInitialMail);

  //username split
  const user = localStorage.getItem(USER_NAME) || "";
  const userSplit = user.trim() ? user.split(" ") : [];
  const userFirstInitial = (userSplit[0] || "U").charAt(0).toUpperCase();
  const userSecondInitial = (userSplit[1] || "").charAt(0).toUpperCase();
  const userInitials = concat(userFirstInitial, userSecondInitial);
 
  // condicional para corregir el undefined en el navprofile
  const hasUserName = Boolean(userSplit[0]) && userSplit[0] !== 'undefined';
  const conditionInitials = hasUserName ? userInitials : initialsEmails;
  const conditionUsers = hasUserName ? user : correoBeforeAt;

  const profileMenu = (
    <div className="nav-profile nav-dropdown">
      <div className="nav-profile-header">
        <div className="d-flex">
          <Avatar size={45}>{conditionInitials}</Avatar>
          <div className="pl-3 pt-2">
            <h4 className="mb-0">{conditionUsers}</h4>
          </div>
        </div>
      </div>
      <div className="nav-profile-body">
        <Menu>
          {menuItem.map((el, i) => {
            return (
              <Menu.Item key={i}>
                <Link to={el.path}>
                <Icon className="mr-3" type={el.icon} />
                <span className="font-weight-normal">{el.title}</span>
                  </Link>
              </Menu.Item>
            );
          })}
          <Menu.Item key={menuItem.length + 1} onClick={onSignOut}>
            <span>
              <LogoutOutlined className="mr-3" />
              <span className="font-weight-normal">Cerrar Sesión</span>
            </span>
          </Menu.Item>
        </Menu>
      </div>
    </div>
  );
  return (
    <Dropdown placement="bottomRight" overlay={profileMenu} trigger={["click"]}>
      <div
        className="d-flex align-item-center"
        role="button"
        tabIndex={0}
        onKeyDown={(event) => {
          if (event.key === "Enter" || event.key === " ") {
            event.preventDefault();
            event.currentTarget.click();
          }
        }}
      >
        <Avatar>{conditionInitials}</Avatar>
      </div>
    </Dropdown>
  );
};

export default connect(null, { signOutAction })(NavProfile);
